import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { STR_DISTRICT, STR_REGION, STR_STREET, STR_WARD, STR_ROAD, STR_HOUSE } from "../Strings";
import { MdLocationPin, MdOutlineArrowDropDown } from "react-icons/md";

export default function NapaAddressPicker({ callback, value }) {
    const appContext = useContext(AppContext);
    const lang = appContext.language;

    const [loading, setLoading] = useState(false);
    const [allRegions, setAllRegions] = useState([]);
    const [allDistricts, setAllDistricts] = useState([]);
    const [allWards, setAllWards] = useState([]);
    const [allStreets, setAllStreets] = useState([]);

    // We use the existing logic but clean up the structure
    useEffect(() => {
        appContext.getRegions().then(setAllRegions);
    }, []);

    // Helper to find ID and name together
    const findSelected = (list, name) => list?.find(item => item.name === name) || null;

    const onRegionChange = async (name) => {
        const item = findSelected(allRegions, name);
        const id = item?.id || null;
        
        // Reset children
        setAllDistricts([]); setAllWards([]); setAllStreets([]);
        callback({ ...value, region: name, regionId: id, district: "", districtId: null, ward: "", wardId: null, street: "", streetId: null });

        if (id) {
            setLoading(true);
            const data = await appContext.getDistricts({ regionId: id });
            setAllDistricts(data);
            setLoading(false);
        }
    };

    const onDistrictChange = async (name) => {
        const item = findSelected(allDistricts, name);
        const id = item?.id || null;

        setAllWards([]); setAllStreets([]);
        callback({ ...value, district: name, districtId: id, ward: "", wardId: null, street: "", streetId: null });

        if (id) {
            setLoading(true);
            const data = await appContext.getWards({ districtId: id });
            setAllWards(data);
            setLoading(false);
        }
    };

    const onWardChange = async (name) => {
        const item = findSelected(allWards, name);
        const id = item?.id || null;

        setAllStreets([]);
        callback({ ...value, ward: name, wardId: id, street: "", streetId: null });

        if (id) {
            setLoading(true);
            const data = await appContext.getStreets({ wardId: id });
            setAllStreets(data);
            setLoading(false);
        }
    };

    const onStreetChange = (name) => {
        const item = findSelected(allStreets, name);
        callback({ ...value, street: name, streetId: item?.id || null });
    };

    const SelectField = ({ label, options, current, onChange, disabled }) => (
        <div className="picker-field">
            <label className="picker-label">{label}</label>
            <div className={`picker-select-wrapper ${disabled ? 'disabled' : ''}`}>
                <select 
                    value={current || ""} 
                    onChange={(e) => onChange(e.target.value)}
                    disabled={disabled}
                >
                    <option value="">Select...</option>
                    {options?.map((opt, i) => (
                        <option key={i} value={opt.name}>{opt.name}</option>
                    ))}
                </select>
                <MdOutlineArrowDropDown className="select-arrow" />
            </div>
        </div>
    );

    return (
        <div className="address-picker-container">
            <div className="picker-grid">
                <SelectField 
                    label={STR_REGION[lang]} 
                    options={allRegions} 
                    current={value?.region} 
                    onChange={onRegionChange} 
                />
                <SelectField 
                    label={STR_DISTRICT[lang]} 
                    options={allDistricts} 
                    current={value?.district} 
                    onChange={onDistrictChange}
                    disabled={!value?.region}
                />
                <SelectField 
                    label={STR_WARD[lang]} 
                    options={allWards} 
                    current={value?.ward} 
                    onChange={onWardChange}
                    disabled={!value?.district}
                />
                <SelectField 
                    label={STR_STREET[lang]} 
                    options={allStreets} 
                    current={value?.street} 
                    onChange={onStreetChange}
                    disabled={!value?.ward}
                />
                
            </div>
            
            {loading && <div className="picker-inline-loader">Updating options...</div>}
        </div>
    );
}